var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({staticClass:"flex",attrs:{"to":_vm.route}},'router-link',_vm.attrs,false),[_c('Icon',{attrs:{"iconClass":"fas fa-chevron-left mr-8"}}),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.title)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }